/* unplugin-vue-components disabled */import script from "./callback.vue?vue&type=script&setup=true&lang=ts"
export * from "./callback.vue?vue&type=script&setup=true&lang=ts"

import "./callback.vue?vue&type=style&index=0&id=e5b32688&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\17532\\Desktop\\school\\logistics-meet\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5b32688"]])

export default __exports__